/* eslint-disable */
import type { LocalizedString } from "../../../localization/localization.pb";

/**
 * ⚠️ This is not owned or maintained by the Arcade team.
 * Please refer to the official Arcade design system for supported and maintained components.
 *
 * The `list-ordered` element.
 */
export interface ListOrdered {
  /** The list items to be displayed. */
  items?: ListOrderedListItem[];
  /**
   * The variant to be used for the list ordered element.
   * If not provided, `STANDARD` will be used.
   */
  variant?: ListOrderedVariant;
}

export enum ListOrderedVariant {
  CLIENT_COULD_NOT_PARSE_LIST_ORDERED_VARIANT = "CLIENT_COULD_NOT_PARSE_LIST_ORDERED_VARIANT",
  STANDARD = "STANDARD",
  SUBTLE = "SUBTLE",
}

export interface ListOrderedListItem {
  /** The label to be displayed by the list item. */
  label?: LocalizedString;
  /**
   * The body to be displayed by the list item. It's exclusive to the standard variant.
   * If not provided, it should not be displayed.
   */
  body?: LocalizedString;
}
